import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { captureApplicationFromUrl } from './services/PendingApplication';

// Stamped by scripts/with-env.js on every build. Two jobs: it names the build
// that is actually live (read `__BUILD_ID__` in the console, or the build-id
// meta tag in index.html), and because the value differs every time, the
// bundle's contents differ every time — so webpack's content hash changes on
// every deploy and a browser can never serve a cached file under a filename
// the new release also uses.
(window as any).__BUILD_ID__ = process.env.REACT_APP_BUILD_ID;

// Before the first render: a route guard can redirect away from `/` during that
// render and drop ?application= from the URL, so the handoff target has to be
// recorded while the original URL is still intact.
captureApplicationFromUrl();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);

